import styled from "@emotion/styled"
import { Value } from "@stringtale/react"
import Image from "app/files/components/Image"
import type { GetMostViewedLessonsResult } from "app/home/queries/getMostViewedLessons"
import LessonListItemTitle from "app/lessons/components/LessonListItemTitle"
import { CARD_IMAGE_RATIO, DARK_BLUE_COLOR, PX12, PX16 } from "theme/consts"
import Link from "ui/Link"
import Stack from "ui/Stack"
import Text from "ui/Text"

const IMAGE_HEIGHT = 50

const Root = styled(Link)`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  text-decoration: none;
  color: inherit;
`

const Position = styled.span`
  flex-shrink: 0;
  width: 24px;
  font-size: ${PX16};
  font-weight: 900;
  color: ${DARK_BLUE_COLOR};
  line-height: ${IMAGE_HEIGHT}px;
  text-align: center;
`

const Thumbnail = styled.div`
  flex-shrink: 0;
  width: ${IMAGE_HEIGHT * CARD_IMAGE_RATIO}px;
  height: ${IMAGE_HEIGHT}px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
`

const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const ThumbnailPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background: #2871631a;
`

const Content = styled(Stack)`
  min-width: 0;
  padding-top: 2px;
`

const ViewCount = styled(Text)`
  color: ${DARK_BLUE_COLOR};
  opacity: 0.7;
`

type Props = {
  item: GetMostViewedLessonsResult[number]
}

const MostViewedLessonCard = ({ item }: Props) => {
  const { position, viewCount, lesson } = item
  const href = `/les/${lesson.slug}`

  return (
    <Root href={href}>
      <Position>{position}</Position>
      <Thumbnail>
        {lesson.cardImage ? (
          <StyledImage
            file={lesson.cardImage}
            alt={lesson.displayTitle || ""}
            fill
          />
        ) : (
          <ThumbnailPlaceholder />
        )}
      </Thumbnail>
      <Content gap="4px">
        {lesson.displayTitle && (
          <LessonListItemTitle
            title={lesson.displayTitle}
            contentSubject={lesson.contentSubject}
          />
        )}
        <ViewCount size={PX12}>
          <Value
            name="apps.web.src.home.components.mostviewedlessoncard.keer_bekeken"
            format={{ count: viewCount }}
          >
            {`{count}x bekeken`}
          </Value>
        </ViewCount>
      </Content>
    </Root>
  )
}

export default MostViewedLessonCard
